export function hasBrowserAdvertisingPrivacyOptOut(
  browserNavigator = typeof navigator === "undefined" ? null : navigator,
) {
  if (!browserNavigator) return false;
  const doNotTrack = String(browserNavigator.doNotTrack || "")
    .trim()
    .toLowerCase();
  return (
    browserNavigator.globalPrivacyControl === true ||
    doNotTrack === "1" ||
    doNotTrack === "yes"
  );
}
